import { render, staticRenderFns } from "./SearchMetabolite.vue?vue&type=template&id=55518ef8&"
import script from "./SearchMetabolite.vue?vue&type=script&lang=js&"
export * from "./SearchMetabolite.vue?vue&type=script&lang=js&"
import style0 from "./SearchMetabolite.vue?vue&type=style&index=0&id=55518ef8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports